<template>
  <div
    class="popup_wrap"
    style="width:1050px; height:600px;"
  >
    <button
      class="layer_close"
      @click="$emit('close')"
    >
    </button>
    <div class="popup_cont" ><!-- popup_cont -->
      <h1 class="page_title">{{ $t('msg.ONEX010T070.001') }}</h1> <!-- Log 조회 -->
      <div class="tab">
        <ul>
          <li :class="{'on' : (tabName === 'ShippingLogBookingPop' ? true : false)}"><a @click.prevent="changeTab('ShippingLogBookingPop')">{{ $t('msg.ONEX010T070.002') }}</a></li> <!-- Booking Log -->
          <li v-if="propData.blNo" :class="{'on' : (tabName === 'ShippingLogBLPop' ? true : false)}"><a @click.prevent="changeTab('ShippingLogBLPop')">{{ $t('msg.ONEX010T070.003') }}</a></li> <!-- B/L Log -->
          <!-- <li :class="{'on' : (tabName === 'ShippingLogDOPop' ? true : false)}"><a href="#"  @click.prevent="changeTab('ShippingLogDOPop')">{{ $t('msg.ONEX010T070.004') }}</a></li> D/O Log  -->
          <!-- <li :class="{'on' : (tabName === 'container' ? true : false)}"><a href="#"  @click.prevent="changeTab('container')">{{ $t('msg.ONEX010T070.005') }}</a></li> Container Log  -->
        </ul>
      </div>
      <keep-alive>
        <component :is="componentName" :prop-data="propData"></component>
      </keep-alive>
    </div><!-- popup_cont -->
  </div><!-- popup_wrap // -->
</template>
<script>

import ShippingLogBookingPop from '@/pages/trans/popup/ShippingLogBookingPop'
import ShippingLogBLPop from '@/pages/trans/popup/ShippingLogBLPop'
import ShippingLogDOPop from '@/pages/trans/popup/ShippingLogDOPop'

export default {
  name: 'ShippingLogPop',
  components: {
    ShippingLogBookingPop,
    ShippingLogBLPop,
    ShippingLogDOPop
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          userId: '',
          bkgNo: '',
          blNo: ''
        }
      }
    },
    propTabName: {
      type: String,
      default: 'ShippingLogBookingPop'
    }
  },
  data () {
    return {
      componentName: '',
      tabName: this.propTabName,
      propData: this.parentInfo
    }
  },
  created: function () {

  },
  mounted: function () {
    this.componentName = 'ShippingLogBookingPop'
  },
  methods: {
    changeTab (tabName) {
      this.tabName = tabName
      this.componentName = tabName
    }
  }
}
</script>
